module.exports = __webpack_public_path__ + "img/kubernetes.990e1eb5.png";